
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as labshSBUstzz0F35wgRkhaV_J_45_45hbYn6AynYesUfNut07T8Meta } from "/workd/WORKD/PROJECT_2025/dashboard/core:labs/pages/labs.vue?macro=true";
import { default as indexfDnbYFkbwNqA3AIOEIiwvuYVhZUhknazjlyq3eLcLzUMeta } from "/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/index.vue?macro=true";
import { default as loginsUkqzMzd7TCPXr4e_flT_45AZQ7xCETEM9YXbvLIuo__454Meta } from "/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/login.vue?macro=true";
import { default as logoutGoPc5UuiehwyqWJvxLkw21wk9nyqk7_keUbDI_45VwQ60Meta } from "/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/logout.vue?macro=true";
import { default as indexyZPdvEf94pVLL6gJIxrlKOJwnIAXW11G_GxUsIZzeVoMeta } from "/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/profile/index.vue?macro=true";
import { default as indexOWvd7xl5xqs_7jTSPWa9UVhSimWFqUorEDS3zroLwM4Meta } from "/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/sandbox/index.vue?macro=true";
import { default as JsonEditorPagek9G6cAeMqiRSZUIsxChQ2jR4ZZVARcnOkWOkH0yRnf4Meta } from "/workd/WORKD/PROJECT_2025/dashboard/core:labs/pages/JsonEditorPage.vue?macro=true";
import { default as login_45passwordr37C2qb2Yx87_45eFbCMplGGyiTAIEqY_Zcxt2n5W7REAMeta } from "/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/login-password.vue?macro=true";
import { default as forgot_45password5E5c9xyRSUXylWs_45zTH4ss9_45dJaLrBk9ziVNK6gzlAQMeta } from "/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/forgot-password.vue?macro=true";
import { default as securitypq4unpVEaCnT2I3tJVrkHbDWePpOhqyS_w0mOHjg_45N0Meta } from "/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/profile/security.vue?macro=true";
import { default as indexmaxBWvYViS8_45AcFZfLDRQGEjUR1nNhehfvYwrHfqPKgMeta } from "/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/sandbox/aside/index.vue?macro=true";
import { default as _91code_933q1MYUVa8nP6VNlSux2nsR8C13WAkehSE_8KPr7LI4gMeta } from "/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/reset-password/[code].vue?macro=true";
export default [
  {
    name: "labs",
    path: "/labs",
    meta: labshSBUstzz0F35wgRkhaV_J_45_45hbYn6AynYesUfNut07T8Meta || {},
    component: () => import("/workd/WORKD/PROJECT_2025/dashboard/core:labs/pages/labs.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexfDnbYFkbwNqA3AIOEIiwvuYVhZUhknazjlyq3eLcLzUMeta || {},
    component: () => import("/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginsUkqzMzd7TCPXr4e_flT_45AZQ7xCETEM9YXbvLIuo__454Meta || {},
    component: () => import("/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutGoPc5UuiehwyqWJvxLkw21wk9nyqk7_keUbDI_45VwQ60Meta || {},
    component: () => import("/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/logout.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexyZPdvEf94pVLL6gJIxrlKOJwnIAXW11G_GxUsIZzeVoMeta || {},
    component: () => import("/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/profile/index.vue")
  },
  {
    name: "sandbox",
    path: "/sandbox",
    meta: indexOWvd7xl5xqs_7jTSPWa9UVhSimWFqUorEDS3zroLwM4Meta || {},
    component: () => import("/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/sandbox/index.vue")
  },
  {
    name: "JsonEditorPage",
    path: "/JsonEditorPage",
    component: () => import("/workd/WORKD/PROJECT_2025/dashboard/core:labs/pages/JsonEditorPage.vue")
  },
  {
    name: "login-password",
    path: "/login-password",
    meta: login_45passwordr37C2qb2Yx87_45eFbCMplGGyiTAIEqY_Zcxt2n5W7REAMeta || {},
    component: () => import("/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/login-password.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45password5E5c9xyRSUXylWs_45zTH4ss9_45dJaLrBk9ziVNK6gzlAQMeta || {},
    component: () => import("/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/forgot-password.vue")
  },
  {
    name: "profile-security",
    path: "/profile/security",
    meta: securitypq4unpVEaCnT2I3tJVrkHbDWePpOhqyS_w0mOHjg_45N0Meta || {},
    component: () => import("/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/profile/security.vue")
  },
  {
    name: "sandbox-aside",
    path: "/sandbox/aside",
    meta: indexmaxBWvYViS8_45AcFZfLDRQGEjUR1nNhehfvYwrHfqPKgMeta || {},
    component: () => import("/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/sandbox/aside/index.vue")
  },
  {
    name: "reset-password-code",
    path: "/reset-password/:code()",
    meta: _91code_933q1MYUVa8nP6VNlSux2nsR8C13WAkehSE_8KPr7LI4gMeta || {},
    component: () => import("/workd/WORKD/PROJECT_2025/IKAMAI/MOBIL/dashboard:client/pages/reset-password/[code].vue")
  }
]